import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Heading from "atoms/Heading";
import Text from "atoms/Text";
import InputLabel from "atoms/InputLabel";
import InputField from "atoms/InputField";
import Button from "atoms/Button";
import Dropdown from "../molecules/Dropdown";
import { getCountryCallingCode } from "react-phone-number-input/input";
import IconWithHeading from "molecules/IconWithHeading";
import Image from "next/image";
import Footer from "organisms/Footer";

const CandidateLoginForm = ({
  theme,
  handleSubmit,
  control,
  error,
  register,
  loginDetails,
  handleCountryChange,
  countryOptionsList,
  onSubmit,
  country,
  setError,
  onClickBackArrow,
  setValue,
  getValues,
  companyDetails,
  errors,
  supportText,
}) => {
  const [loginType, setLoginType] = useState(getValues("loginType"));
  const handleMobileNumberChange = (event) => {
    const val = event.target.value.toString();
    if (val.length != 0) {
      setDisabled(false);
      return;
    }
    setDisabled(true);
    setError([]);
  };
  const handleEmailChange = (event) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const val = event.target.value.toString();
    if (emailPattern.test(val)) {
      setDisabled(false);
      return;
    }
    setDisabled(true);
    setError([]);
  };
  const checkDisabled = () => {
    if (loginDetails.loginType === "") return true;
    if (
      loginDetails.loginType === "mobileNumber" &&
      loginDetails.mobileNumber?.length !== 10
    )
      return true;
    if (
      loginDetails.loginType === "email" &&
      loginDetails.emailId?.length === 0
    )
      return true;
    return false;
  };
  const [disabled, setDisabled] = useState(checkDisabled());

  // Check if custom theme is applied
  const hasCustomTheme = Boolean(theme?.template);

  // Custom styles for dropdown when theme is applied
  const customDropdownStyles = hasCustomTheme ? {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'transparent',
      color: 'var(--login-right-text)',
      borderColor: 'var(--login-right-text)',
      boxShadow: 'none',
      '&:hover': {
        borderColor: 'var(--login-right-text)',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      backgroundColor: 'transparent',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'var(--login-right-input-text)',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'var(--login-right-heading)',
      opacity: 0.6,
    }),
    input: (provided) => ({
      ...provided,
      color: 'var(--login-right-input-text)',
    }),
  } : {};

  // Custom classes based on theme
  const customClasses = hasCustomTheme ? {
    dropdown: 'themed-dropdown',
    inputField: 'ml-1 themed-input text-[color:var(--login-right-input-text)] !border-[color:var(--login-right-text)]',
    inputBg: 'bg-transparent',
    mobileInputBorderRadius: 'rounded-lg',
    emailInputBorderRadius: 'rounded-lg',
    divider: 'bg-[color:var(--login-right-text)]',
  } : {
    dropdown: '',
    inputField: 'ml-1',
    inputBg: 'bg-lightGrey',
    mobileInputBorderRadius: 'rounded-none',
    emailInputBorderRadius: 'rounded-xl',
    divider: 'bg-gray-300',
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <form
        className="w-full"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="w-full mb-8 text-center">
          <Heading
            type="h4"
            className="font-semibold md:text-[32px] sm:text-[24px] text-[22px] text-[color:var(--login-right-heading)]"
          >
            Your journey starts here
          </Heading>
          <Text className="mt-3 text-sm font-medium leading-[26px] text-[color:var(--login-right-body)] opacity-80">
            {loginType === "mobileNumber"
              ? "Enter your mobile number to receive an OTP"
              : "Enter your email to receive an OTP"}
          </Text>
        </div>
            {loginType === "mobileNumber" ? (
              <>
                {/* <InputLabel textColor="text-gray-700">Mobile Number</InputLabel> */}
                <div className="mt-2  flex">
                  <Dropdown
                    name="countryCode"
                    id="countryCode"
                    value={country}
                    onChange={handleCountryChange}
                    defaultValue={+getCountryCallingCode("IN")}
                    options={countryOptionsList}
                    isSearchable={true}
                    className={`w-22.5 select-dropdown rounded-none ${customClasses.dropdown} ${
                      error.length != 0
                        ? " border border-error border-b-error"
                        : ""
                    }`}
                    control={control}
                    customStyles={customDropdownStyles}
                  />
                  <InputField
                    id="mobileNumber"
                    name="mobileNumber"
                    type="number"
                    className={customClasses.inputField}
                    placeholder="Mobile Number"
                    maxLength={10}
                    register={register}
                    isRequired={true}
                    change={handleMobileNumberChange}
                    variant={error.length != 0 ? "error" : "outlineBottom"}
                    error={errors.mobileNumber}
                    bg={customClasses.inputBg}
                    borderRadius={customClasses.mobileInputBorderRadius}
                  />
                </div>
                {error.length != 0 && (
                  <div className="text-sm text-error -mt-4 mb-1">
                    {error.length != 0 && error}
                  </div>
                )}
              </>
            ) : (
              <>
                {/* <InputLabel textColor="text-gray-700">Email</InputLabel> */}
                <div className="mt-2  flex">
                  <InputField
                    id="emailId"
                    name="emailId"
                    type="email"
                    className={customClasses.inputField}
                    placeholder="Enter your Email"
                    register={register}
                    isRequired={true}
                    change={handleEmailChange}
                    variant={error.length != 0 ? "error" : "outlineBottom"}
                    error={errors.emailId}
                    bg={customClasses.inputBg}
                    borderRadius={customClasses.emailInputBorderRadius}
                  />
                </div>
                {error.length != 0 && (
                  <div className="text-sm text-error -mt-4 mb-1">
                    {error.length != 0 && error}
                  </div>
                )}
              </>
            )}

            {/* <Text className="mb-16 md:mb-10 text-sm text-gray-500">
              {`An OTP will be sent via ${loginType === 'email' ? 'email' : 'sms'} to verify your ${loginType === 'email' ? 'email Id' : 'phone number'}`}
            </Text> */}
            <Button
              type="submit"
              variant="normalBtn"
              fontWeight="font-bold"
              btnClass="w-full rounded-xl"
              style={{
                background: disabled
                  ? "var(--login-button-disabled)"
                  : "var(--login-button)",
                color: disabled
                  ? "var(--login-button-disabled-text)"
                  : "var(--login-button-text)",
              }}
              disabled={disabled}
            >
              Get OTP
            </Button>
            <div className=" w-full h-1/5 flex flex-col gap-2 justify-center items-center mt-14">
              <span className={`w-full h-[1px] ${customClasses.divider}`}></span>
              <Button
                type="button"
                variant="normalBtn"
                fontWeight="font-normal"
                {...((!theme?.template || theme.template === "none") && {
                  imgWidth: "16",
                  imgHeight: "16",
                  imgSrc: loginType !== "mobileNumber"
                    ? "/images/icons/mobileBlack.svg"
                    : "/images/icons/message.svg"
                })}
                onClick={() => {
                  setLoginType((prev) => {
                    setError([]);
                    setDisabled(
                      getValues(
                        prev === "mobileNumber" ? "emailId" : "mobileNumber"
                      ) === null ||
                        getValues(
                          prev === "mobileNumber" ? "emailId" : "mobileNumber"
                        ) === undefined ||
                        getValues(
                          prev === "mobileNumber" ? "emailId" : "mobileNumber"
                        ) === ""
                    );
                    setValue(
                      "loginType",
                      prev === "mobileNumber" ? "email" : "mobileNumber"
                    );
                    return prev === "mobileNumber" ? "email" : "mobileNumber";
                  });
                  // setValue('loginType',loginType)
                }}
              >
                {loginType !== "mobileNumber"
                  ? "Login with Mobile Number"
                  : "Login with Email"}
              </Button>
              {/* <Button
                onClick={() => {
                  setLoginType((prev) => {
                    setError([])
                    setDisabled(getValues(prev === 'mobileNumber' ? 'emailId' : 'mobileNumber') === null || getValues(prev === 'mobileNumber' ? 'emailId' : 'mobileNumber') === undefined || getValues(prev === 'mobileNumber' ? 'emailId' : 'mobileNumber') === '')
                    setValue('loginType', prev === 'mobileNumber' ? 'email' : 'mobileNumber')
                    return prev === 'mobileNumber' ? 'email' : 'mobileNumber'

                  })
                  // setValue('loginType',loginType)  
                }}
                type='button'
                variant="primaryBtn"
                fontWeight="font-bold"
                btnClass="w-full mt-5">



                Login with {loginType === 'mobileNumber' ? 'Email' : 'Mobile Number'}
              </Button> */}
            </div>
        {supportText && (
          <p className="mt-10 text-sm text-[color:var(--login-right-body)] text-center leading-6 opacity-80">
            {supportText}
          </p>
        )}
      </form>
    </div>
  );
};

export default CandidateLoginForm;

CandidateLoginForm.propTypes = {
  loginDetails: PropTypes.object,
  error: PropTypes.string,
  theme: PropTypes.object,
  supportText: PropTypes.string,
};
